import { render, staticRenderFns } from "./invite-client-admin-dialog.component.vue?vue&type=template&id=55636233"
import script from "./invite-client-admin-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./invite-client-admin-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports